import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { FoljaMenyra, FoljaNumri, FoljaPeremri, FoljaUrdheroreTrajtaTeShkurtraTeBashkuara } from '@core/enums/folja.enum';
import { FoljaUrdherore } from '@core/globals/folja/folja-urdherore-constants';
import { FoljaUrdheroreTrajtaTeShkurtraTeBashkuaraForCreationDTO } from '@core/interfaces/dto/folja-urdherore-trajta-te-shkurtra-te-bashkuara-for-creation-dto.interface';
import { FoljaBaza } from '@core/interfaces/models/folja-baza.interface';
import { FoljaUrdheroreTrajtaTeShkurtraTeBashkuaraFormulaService } from './folja-urdherore-trajta-te-shkurtra-te-bashkuara-formula.service';

@Injectable({
  providedIn: 'root',
})
export class FoljaUrdheroreTrajtaTeShkurtraTeBashkuaraService {
  constructor(
    private foljaUrdheroreTrajtaTeShkurtraTeBashkuaraFormulaService: FoljaUrdheroreTrajtaTeShkurtraTeBashkuaraFormulaService,
    private fb: UntypedFormBuilder
  ) { }

  insertForms(foljaBaza: FoljaBaza, form: UntypedFormGroup) {
    let formArrays = ['foljaBaza.foljaUrdheroreTrajtaTeShkurtraTeBashkuaraInitial', 'foljaBaza.foljaUrdheroreTrajtaTeShkurtraTeBashkuara'];
    for (let i = 0; i < formArrays.length; i++) {
      const formArray = form.get(formArrays[i]) as UntypedFormArray;
      this.generateUrdheroreForms(formArray);
      foljaBaza.foljaUrdheroreTrajtaTeShkurtraTeBashkuara?.forEach((item) => {
        let index = formArray.controls.findIndex(
          (c) =>
            c.get('numriId')?.value == item.numriId &&
            c.get('trajtaTeShkurtraTeBashkuaraId')?.value == item.trajtaTeShkurtraTeBashkuaraId &&
            c.get('pershkrimi')?.value == '' &&
            c.get('renditja')?.value == item.renditja
        );
        if (index != -1) {
          formArray.controls[index].get('pershkrimi')?.setValue(item.pershkrimi);
        } else {
          this.addNewLakimi(formArray, item.numriId, item.trajtaTeShkurtraTeBashkuaraId, item.pershkrimi, item.renditja);
        }
      });
    }
  }

  generateForms(formArray: UntypedFormArray) {
    this.generateUrdheroreForms(formArray);
  }

  generateFormula(baza: string, foljaBaza: FoljaBaza, form: UntypedFormGroup) {
    this.foljaUrdheroreTrajtaTeShkurtraTeBashkuaraFormulaService.generateFormula(
      baza,
      foljaBaza,
      form.get('foljaBaza.foljaUrdheroreTrajtaTeShkurtraTeBashkuara') as UntypedFormArray
    );
  }

  private generateUrdheroreForms(formArray: UntypedFormArray) {
    while (formArray.length > 0) {
      formArray.removeAt(0);
    }

    for (const fn of FoljaUrdherore.FoljaNumri) {
      for (const fttshb of FoljaUrdherore.FoljaUrdheroreTrajtaTeShkurtraTeBashkuara) {
        const foljaForm = this.fb.group({
          numriId: fn.id,
          trajtaTeShkurtraTeBashkuaraId: fttshb.id,
          pershkrimi: '',
          renditja: 1
        });

        formArray.push(foljaForm);
      }
    }
  }

  addNewLakimi(formArray: UntypedFormArray, numri: FoljaNumri, ttshb: FoljaUrdheroreTrajtaTeShkurtraTeBashkuara, pershkrimi?: string, renditja?: number) {
    const renditjet = formArray.value.filter((c: any) => c.numriId == numri && c.trajtaTeShkurtraTeBashkuaraId == ttshb).map((c: any) => c.renditja);
    const prevIndex = Math.max(...(renditjet.length > 0 ? renditjet : [0]));
    const foljaForm = this.fb.group({
      // formaId: forma,
      numriId: numri,
      trajtaTeShkurtraTeBashkuaraId: ttshb,
      pershkrimi: pershkrimi,
      renditja: renditja ?? prevIndex + 1
    });
    formArray.push(foljaForm);
  }

  getCreationDTO(form: UntypedFormGroup) {
    const creationDTO: FoljaUrdheroreTrajtaTeShkurtraTeBashkuaraForCreationDTO[] = [];

    let formArray: UntypedFormArray;

    formArray = form.get('foljaBaza.foljaUrdheroreTrajtaTeShkurtraTeBashkuara') as UntypedFormArray;

    formArray.getRawValue().forEach((e: any) => {
      creationDTO.push({
        numriId: e.numriId,
        trajtaTeShkurtraTeBashkuaraId: e.trajtaTeShkurtraTeBashkuaraId,
        pershkrimi: e.pershkrimi,
        renditja: e.renditja
      });
    });

    return creationDTO;
  }

  getErrors(foljaForm: UntypedFormGroup) {
    let errors: { menyraId: number; numriId?: number; trajtaTeShkurtraTeBashkuaraId: number, pershkrimi: string }[] = [];
    let initial = foljaForm.getRawValue().foljaUrdheroreTrajtaTeShkurtraTeBashkuaraInitial;
    let formula = foljaForm.getRawValue().foljaUrdheroreTrajtaTeShkurtraTeBashkuara;

    for (const fn of FoljaUrdherore.FoljaNumri) {
      for (const fttshb of FoljaUrdherore.FoljaUrdheroreTrajtaTeShkurtraTeBashkuara) {

        const fmap = formula
          .filter((a: any) => a.numriId == fn.id && a.trajtaTeShkurtraTeBashkuaraId == fttshb.id)
          .map((a: any) => a.pershkrimi)
          .join(', ');

        const imap = initial
          .filter((a: any) => a.numriId == fn.id && a.trajtaTeShkurtraTeBashkuaraId == fttshb.id)
          .map((a: any) => a.pershkrimi)
          .join(', ');

        if (fmap != imap) {
          errors.push({
            menyraId: FoljaMenyra.Urdherore,
            numriId: fn.id,
            trajtaTeShkurtraTeBashkuaraId: fttshb.id,
            pershkrimi: imap
          });
        }
      }
    }

    return errors;
  }
}
